// Minimal markdown renderer for the subset used in case studies:
// ## / ### headings, - bullet lists, **bold**, paragraphs.
function renderInline(text, keyPrefix) {
  const parts = text.split(/(\*\*[^*]+\*\*)/g);
  return parts.map((p, i) => {
    if (p.startsWith("**") && p.endsWith("**")) {
      return (
        <strong key={`${keyPrefix}-${i}`} className="text-white font-semibold">
          {p.slice(2, -2)}
        </strong>
      );
    }
    return <span key={`${keyPrefix}-${i}`}>{p}</span>;
  });
}

export default function Markdown({ content = "" }) {
  const lines = content.split("\n");
  const blocks = [];
  let list = [];

  const flushList = (idx) => {
    if (list.length) {
      blocks.push(
        <ul key={`ul-${idx}`} className="my-5 space-y-3">
          {list.map((item, i) => (
            <li key={i} className="flex gap-3 text-zinc-300 leading-relaxed">
              <span className="text-tib-amber mt-1">—</span>
              <span>{renderInline(item, `li-${idx}-${i}`)}</span>
            </li>
          ))}
        </ul>
      );
      list = [];
    }
  };

  lines.forEach((raw, idx) => {
    const line = raw.trim();
    if (line.startsWith("- ")) {
      list.push(line.slice(2));
      return;
    }
    flushList(idx);
    if (!line) return;
    if (line.startsWith("### ")) {
      blocks.push(
        <h3 key={idx} className="h-serif text-2xl text-white mt-10 mb-3">{line.slice(4)}</h3>
      );
    } else if (line.startsWith("## ")) {
      blocks.push(
        <h2 key={idx} className="h-serif text-3xl text-white mt-12 mb-4">{line.slice(3)}</h2>
      );
    } else {
      blocks.push(
        <p key={idx} className="text-zinc-300 leading-relaxed my-4 text-lg">
          {renderInline(line, `p-${idx}`)}
        </p>
      );
    }
  });
  flushList("end");

  return <div>{blocks}</div>;
}
